(function(module) {
  'use strict';
  module
    .directive('resizer', ['$document', '$timeout', function($document, $timeout) {
      return function($scope, $element, $attrs) {
        $element.on('mousedown', function(event) {
          event.preventDefault();
          $document.on('mousemove', mousemove);
          $document.on('mouseup', mouseup);
        });

        /*
        Directive scheme

        <div resizer="vertical/horizontal" resizer-height="number" resizer-top="#id" resizer-bottom="#id" resizer-offset-element="?#id" 
        resizer-top-bound="?number" resizer-bottom-bound="?number" resizer-top-padding-bottom="number"></div>
        */

        // Default fallback attribute values
        if (!($attrs.resizerOffsetElement)) {$attrs.resizerOffsetElement = $attrs.resizerTop;}
        if (!($attrs.resizerTopBound)) {$attrs.resizerTopBound = 0;}
        if (!($attrs.resizerBottomBound)) {$attrs.resizerBottomBound = 1080;}

        // Grab offsets on document ready
        var offset;
        var padding;

        angular.element(document).ready(function () {
          // Hacky -- wait for angular to load DOMs before grabbing
          $timeout(function() {
            offset = $($attrs.resizerOffsetElement).offset() || {left: 0, top: 0,}; //jquery -- tofix
            padding = parseInt($attrs.resizerTopPaddingBottom) + parseInt($attrs.resizerHeight) || parseInt($attrs.resizerHeight);
          }, 500);
        });

        function mousemove(event) {
          if ($attrs.resizer == 'vertical') {
            // Handle vertical orientation resizer (i.e. drag left/right)
            var x = event.pageX;
            if ($attrs.resizerMax && x > $attrs.resizerMax) {
              x = parseInt($attrs.resizerMax);
            }
            $element.css({
              left: x + 'px'
            });
            $($attrs.resizerLeft).css({
              width: x + 'px'
            });
            $($attrs.resizerRight).css({
              left: (x + parseInt($attrs.resizerWidth)) + 'px'
            });
          } else {

            // Handle horizontal orientation resizer (i.e. drag up/down)
            var y = event.pageY - offset.top;
            if (y > $attrs.resizerTopBound && y < $attrs.resizerBottomBound) {
              $element.css({
                top: y + 'px'
              });
              $($attrs.resizerTop).css({
                  height: (y - padding + 1) + 'px'
              });
            }
          }
        }

        function mouseup() {
          $document.unbind('mousemove', mousemove);
          $document.unbind('mouseup', mouseup);
        }
      };
    }]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/directives/resizer.directive.js